import { Link, useParams } from "react-router-dom";

const SECTIONS = {
  terms: {
    title: "Terms of Service",
    body: `Last Updated: February 1, 2026

1. ELIGIBILITY & CONSENT
By using Purple Partnerships you affirm:
• You are 21+ and legally capable of consenting to marriage in your jurisdiction.
• You are not seeking marriage for immigration fraud (violations reported under 8 U.S.C. § 1325).
• You understand this platform is for platonic partnerships only (FOSTA-SESTA compliance).

2. PROHIBITED CONDUCT
Immediate ban + legal reporting for:
• Fraud — Misrepresenting orientation, intent, or identity.
• Abuse — History of domestic violence (VAWA) or stalking (18 U.S.C. § 2261A).
• Exploitation — Soliciting payments or citizenship benefits (18 U.S.C. § 1546).
• Discrimination — Hate speech targeting protected classes.

3. SCREENING & SAFETY
• Mandatory ID verification (SOC-2 compliant service).
• Optional background checks (FCRA § 604 compliant — requires consent).
• Mental health disclosures are voluntary (ADA-compliant).

4. LIABILITY LIMITS
Platform disclaims responsibility under Section 230. Disputes are subject to binding arbitration under the FAA.

5. TERMINATION
We reserve the right to suspend or terminate access at any time for lying during screenings, harassment, bigotry, predatory behavior, or violating laws.`,
  },
  privacy: {
    title: "Privacy Policy",
    body: `CCPA / GDPR Aligned. Last Updated February 1, 2026.

1. DATA COLLECTED
• Personal: name, email, age/DOB, ID document (for verification).
• Sensitive: sexual orientation, gender identity (voluntary; used only for matching).

2. USER RIGHTS (CCPA)
• Opt-out / deletion: request data deletion at any time except legal/audit records.
• Do Not Sell: we do not sell personal data to third parties.

3. FEDERAL COMPLIANCE
• FISA / Patriot Act: data shared only with valid subpoenas.
• COPPA: strict 21+ age gate — no underage users.

4. SHARING
We never share screening data except for legal compliance (subpoenas, fraud investigations) or safety emergencies (threats of harm).`,
  },
  disclaimer: {
    title: "Legal Disclaimer",
    body: `⚠️ GENERAL LEGAL DISCLAIMER — PLEASE READ.

1. NO GUARANTEE OF SAFETY, COMPATIBILITY, OR OUTCOMES
This platform is a technology service only. We do not screen, background check, investigate, endorse, verify, or guarantee the identity, character, intentions, health, legal status, or conduct of any user. All interactions — online or offline — occur entirely at your own risk.

2. ASSUMPTION OF ALL RISKS
You voluntarily assume all risks including emotional distress, fraud, catfishing, harassment, stalking, physical injury, sexual assault, exposure to STIs, or financial loss.

3. NO DUTY TO PROTECT OR MONITOR USERS
To the fullest extent permitted by law: we owe no duty of care to protect users from the acts of other users, and any safety features are provided voluntarily.

4. USER RESPONSIBILITY
You alone are responsible for verifying the identity and intentions of others. Meet in public, inform trusted contacts, and discontinue interactions that raise concerns.

5. DISCLAIMER OF WARRANTIES
Service provided "AS IS" and "AS AVAILABLE" without warranties of any kind.

6. LIMITATION OF LIABILITY
Total liability shall not exceed the greater of $100 or the amount paid by the user in the prior 12 months.

7. WAIVER & RELEASE OF CLAIMS
You irrevocably release all claims arising from interactions with other users, content posted by users, or platform decisions.

8. ARBITRATION (CRITICAL)
ALL DISPUTES SHALL BE RESOLVED BY BINDING INDIVIDUAL ARBITRATION, NOT IN COURT.
• No class actions • No collective claims • Confidential • Jury trial waived.
Claims must be brought within ONE (1) YEAR or are permanently barred.

12. ACKNOWLEDGMENT
By using this platform you acknowledge that you have read and understood this disclaimer, accept the risks, and voluntarily choose to participate.`,
  },
  guidelines: {
    title: "Community Guidelines",
    body: `ZERO TOLERANCE for:
1. Immigration fraud (reported to DHS).
2. Revenge porn (18 U.S.C. § 2261B).
3. Hate speech based on sexual orientation/gender.
4. Catfishing or misrepresentation.

SUPPORT RESOURCES
• LGBTQ+ Crisis Hotline: 988 (press 3).
• Trevor Project: 1-866-488-7386.
• Report abuse in-app or email purplepartnerships@proton.me.`,
  },
};

export default function Legal() {
  const { tab = "terms" } = useParams();
  const s = SECTIONS[tab] || SECTIONS.terms;
  return (
    <div className="min-h-screen p-6" style={{ background: "var(--lavender)" }}>
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="text-white/80 hover:text-white text-sm" data-testid="legal-back">← Home</Link>
        <div className="flex gap-2 mt-4 mb-6 flex-wrap">{Object.entries(SECTIONS).map(([k, v]) => (
          <Link key={k} to={`/legal/${k}`} data-testid={`legal-tab-${k}`} className={`px-4 py-2 rounded-full text-sm border ${tab === k ? "bg-[#FF1493] border-[#FF1493] text-white" : "text-white border-white/30 hover:bg-white/10"}`}>{v.title}</Link>
        ))}</div>
        <article className="glass rounded-2xl p-8 text-white" data-testid="legal-content">
          <h1 className="font-display text-3xl font-extrabold mb-4">{s.title}</h1>
          <pre className="whitespace-pre-wrap font-sans text-white/90 text-sm leading-relaxed">{s.body}</pre>
        </article>
      </div>
    </div>
  );
}
